import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFSelect.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  onSelect: PropTypes.any, 
  onClick: PropTypes.any,
  defaultValue: PropTypes.any,
};

export default function RHFSelect({ name, children,defaultValue, onSelect, onClick,disabled, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      
      render={({ field, fieldState: { error, } }) => (
        <TextField
          {...field}
          
          select
          fullWidth
          SelectProps={{ native: true }}
          error={!!error}
          helperText={error?.message}
          defaultValue={'chse...'}
          {...other}
          onSelect={onSelect}
          onClick={onClick}
          disabled={disabled}
          
        >
          {children}
        </TextField>
      )}
    />
  );
}
